<template>
  <div class="address-pick">
    <div class="product-address flex">
      <span class="word">{{ TLang('送至','my') }}</span>
      <div
        class="drop-down"
        @click.stop="showSelectAddress"
      >
        <i class="icon iconfont pdp_location vertical-middle geo">&#xe64f;</i>
        <span
          class="line-clamp-1"
          style="max-width: 260px"
        >
          {{
            addressInfo.provinceName +
              addressInfo.cityName +
              (addressInfo.regionName || addressInfo.districtName) +
              addressInfo.streetName +
              (addressInfo.address ? addressInfo.address : "")
          }}
        </span>
        <p :class="[showArea ? 'direcUp' : 'direcDown']">
          <i :class="['icon', 'iconfont', 'vertical-middle']">&#xe646;</i>
        </p>
        <!-- 原来这么阻止冒泡 -->
        <div
          class="chooseAddress"
          :style="{
            height: showArea ? (!height ? '340px' : height + 'px') : '0',
            borderWidth: showArea ? '1px' : '0',
            width: width + 'px'
          }"
          @click.stop
        >
          <div class="title">
            <span>{{ TLang('选择新地址','my') }}</span>
            <div @click="showArea = false">
              <i
                class="icon iconfont pdp_location vertical-middle close-icon"
              >&#xe64b;</i>
            </div>
          </div>
          <div
            :class="CookiesOne=='en-US'?'checkoutAddressBtn checkoutAddressBtn-One':'checkoutAddressBtn' "
            @click="
              () => {showUserList = !showUserList;}
            "
          >
            <span>{{ TLang('选择新地址','my') }}</span>
            <i
              :class="[
                'icon',
                'iconfont',
                'vertical-middle',
                showUserList ? 'direcUp' : 'direcDown'
              ]"
            >&#xe646;</i>
          </div>
          <div
            v-if="showUserList"
            class="address-content"
          >
            <p>{{ TLang('常用地址','list') }}</p>
            <ul :style="{ maxHeight: height ? '120px' : '180px' }">
              <li
                v-for="address in userAddressList"
                :key="address.id"
                @click="chooseUserAddress(address)"
              >
                <i
                  class="icon iconfont pdp_location vertical-middle geo"
                >&#xe64f;</i>
                {{
                  address.provinceName +
                    address.cityName +
                    (address.regionName || address.districtName) +
                    address.streetName +
                    (address.address ? address.address : "")
                }}
              </li>
            </ul>
          </div>
          <div v-else>
            <selectArea :getCityId="this.getCityId" />
          </div>
        </div>
      </div>
      <div
        v-if="stockFreight && stockFreight.bizStock === null"
        :class="{ stock: true, noStock: stockFreight.stockStatus >= 3 }"
      >
        {{ stockFreight.stockStatus === 3 ? TLang('补货中', 'list') : TLang(stockFreight.stockStatusName, 'list') }}
      </div>
      <div
        v-if="stockFreight && typeof stockFreight.bizStock === 'number'"
        :class="{ stock: true, noStock: stockFreight.bizStock === 0 }"
      >
        {{ stockFreight.bizStock === 0 ? TLang('抢光了', 'list') : stockFreight.bizStock >= 20 ? TLang('货源充足', 'list') : TLang('货源稀少', 'list') }}
      </div>
      <ul
        v-if="showFeight"
        class="logistics flex"
      >
        <!-- <li v-if="stockFreight.goodsFreight === 0">
          <p>
            包邮
          </p>
        </li>
        <li v-if="stockFreight.packageMailDesc">
          <p :style="{maxWidth: '340px'}">
            {{ stockFreight.packageMailDesc.replace( /(\d)(\.?)(\d+)?/g, function($0){return $0 * union_scale}).replace(/福豆/g, union_name) }}
          </p>
        </li> -->
        <li>
          <p :style="{maxWidth: '232px', textAlign: 'right',padding: '4px 0', lineHeight: '20px'}">
            {{ getFreightText() }}
          </p>
        </li>
      </ul>
    </div>
    <div
      v-if="stockFreight.stockStatus < 3 && stockFreight.status === '1' && epidemicDeliverInfo.allowDelivery === 0 && epidemicDeliverInfo.promptWords"
      class="epidemicDeliverTip"
    >
      <div>{{ epidemicDeliverInfo.promptWords }}</div>
    </div>
  </div>
</template>

<script>
import selectArea from '@components/selectArea';
import * as addressApiV2 from '@fetch/addressV2';
import Cookies from 'js-cookie';
export default {
  components: { selectArea },
  props: {
    stockFreight: {
      type: Object,
      default: function() {
        return {};
      },
    },
    epidemicDeliverInfo: {
      type: Object,
      default: function() {
        return {
          allowDelivery: null,
          mandatoryType: null,
          promptWords: null,
        };
      },
    },
    onAddressChange: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    showFeight: {
      type: Boolean,
      default: false,
    },
    height: String,
    width: String,
  },
  data() {
    return {
      // union_name: window.union_name || TLang('福豆', 'card'),
      // union_scale: window.union_scale || 1,
      areaList: [],
      showArea: false,
      userAddressList: [],
      showUserList: false,
      addressInfo: Cookies.get('address') && JSON.parse(Cookies.get('address')),
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  mounted() {
    this.$nextTick(function() {
      addressApiV2.getUserAddressListV2({ignore: true}).then(data => {
        this.userAddressList = data.records;
        this.showUserList = !!data.records;
      });
    });
  },
  methods: {
    showSelectAddress() {
      this.showArea = !this.showArea;
    },
    chooseUserAddress(address) {
      if (address.checkResultType === 0) {
        this.$message.error(address.checkMsg);
        return;
      }

      this.showArea = false;
      this.addressInfo = address;
      this.onAddressChange && this.onAddressChange(address);
    },
    getCityId(address) {
      this.showArea = false;
      this.addressInfo = {
        provinceId: (address[0] && address[0].id) || '',
        provinceName: (address[0] && address[0].name) || '',
        cityName: (address[1] && address[1].name) || '',
        cityId: (address[1] && address[1].id) || '',
        regionName: (address[2] && address[2].name) || '',
        regionId: (address[2] && address[2].id) || '',
        streetName: (address[3] && address[3].name) || '',
        streetId: (address[3] && address[3].id) || '',
        address: '',
      };
      this.onAddressChange && this.onAddressChange(this.addressInfo);
    },
    getFreightText() {
      let str = this.TLang('包邮','my');
      if (this.stockFreight.freightShowType) {
        switch (this.stockFreight.freightShowType) {
        case 1:
          str = this.TLang('包邮','my');
          break;
        case 2:
          // str = `实付金额满${parseFloat((this.stockFreight.freeShipMoney* union_scale).toFixed(2))}${window.union_name || this.TLang('福豆', 'card')}包邮，不满时需支付基础运费${parseFloat((this.stockFreight.postageMoney* union_scale).toFixed(2))}${window.union_name || this.TLang('福豆', 'card')}`;
          str = this.ReplaceText(
            'MMM',
            parseFloat((this.stockFreight.freeShipMoney* union_scale).toFixed(2)),
            this.ReplaceText(
              'YYY',
              parseFloat((this.stockFreight.postageMoney* union_scale).toFixed(2)),
              this.ReplaceText(
                'UUU',
                window.union_name || this.TLang('福豆', 'card'),
                this.TLang('实付金额满包邮不满运费', 'goods'),
                true,
              ),
            ));
          break;
        case 3:
          // str = `免运费（${this.stockFreight.freeShipWeight}kg内包邮，超重${parseFloat((this.stockFreight.postageWeight* union_scale).toFixed(2))}${window.union_name || this.TLang('福豆', 'card')}/kg）`;
          '免运费超重';
          str = this.ReplaceText(
            'MMM',
            this.stockFreight.freeShipWeight,
            this.ReplaceText(
              'CCC',
              parseFloat((this.stockFreight.postageWeight* union_scale).toFixed(2)),
              this.ReplaceText(
                'UUU',
                window.union_name || this.TLang('福豆', 'card'),
                this.TLang('免运费超重', 'goods'),
                true,
              ),
            ));
          break;
        case 4:
          // str = `实付金额满${parseFloat((this.stockFreight.freeShipMoney* union_scale).toFixed(2))}${window.union_name || this.TLang('福豆', 'card')}（${this.stockFreight.freeShipWeight}kg内）包邮，不满时需支付基础运费${parseFloat((this.stockFreight.postageMoney* union_scale).toFixed(2))}${window.union_name || this.TLang('福豆', 'card')}，续重${parseFloat((this.stockFreight.postageWeight* union_scale).toFixed(2))}${window.union_name || this.TLang('福豆', 'card')}/kg`;
          str = this.ReplaceText(
            'MMM',
            parseFloat((this.stockFreight.freeShipMoney* union_scale).toFixed(2)),
            this.ReplaceText(
              'YYY',
              parseFloat((this.stockFreight.postageMoney* union_scale).toFixed(2)),
              this.ReplaceText(
                'QQQ',
                this.stockFreight.freeShipWeight,
                this.ReplaceText(
                  'CCC',
                  parseFloat((this.stockFreight.postageWeight* union_scale).toFixed(2)),
                  this.ReplaceText(
                    'UUU',
                    window.union_name || this.TLang('福豆', 'card'),
                    this.TLang('实付金额满包邮不满运费续重', 'goods'),
                    true,
                  ),
                ),
              ),
            ));
          break;
        default:
          break;
        }
      }
      else if (!this.stockFreight.freightShowType && this.stockFreight.goodsFreight === 0) {
        str = this.TLang('包邮','my');
      } else if (!this.stockFreight.freightShowType && this.stockFreight.packageMailDesc) {
        str = this.stockFreight.packageMailDesc.replace(/(\d)(\.)?(\d+)?/g, ($0) => $0 * union_scale).replace(/福豆/g, window.union_name || this.TLang('福豆', 'card'));
      }
      return str;
    },
  },
};
</script>

<style lang="less" scoped>
.address-pick {
  .product-address {
    font-size: 13px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 28px;
    // margin-top: 16px;
    margin-bottom: -10px;
    .word {
      font-size: 12px;
      color: rgba(153, 153, 153, 1);
    }
    .drop-down {
      border: 1px solid rgba(229, 229, 229, 1);
      padding: 0 5px;
      text-align: center;
      margin-left: 24px;
      display: flex;
      align-items: center;
      position: relative;
      max-width: 400px;
      span {
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
        line-height: 32px;
      }
      p.direcUp {
        transform: rotate(180deg);
        transition: all 0.2s ease-in;
        transform-origin: center;
      }
      p.direcDown {
        transform: rotate(0deg);
        transition: all 0.2s ease-in;
        transform-origin: center;
      }
      &:hover {
        cursor: pointer;
      }
      .chooseAddress {
        position: absolute;
        width: 600px;
        // height: 400px;
        left: -1px;
        top: 100%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(229, 229, 229, 1);
        z-index: 9;
        // padding: 24px;
        box-sizing: border-box;
        overflow: hidden;
        transition: all 0.2s ease-in;
        .title {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          padding: 16px 20px 0;
        }
      }
      .checkoutAddressBtn {
        text-align: left;
        height: 30px;
        width: 107px;
        padding: 0 8px;
        border: 1px solid rgba(204, 204, 204, 1);
        font-size: 12px;
        color: rgba(153, 153, 153, 1);
        // margin-top: 12px;
        margin: 12px 20px;
        i {
          float: right;
          margin-top: 2px;
        }
      }
      .checkoutAddressBtn-One{
        width: 159px;
      }
      .address-content {
        text-align: left;
        p {
          padding: 0px 20px;
          font-size: 14px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
        ul {
          overflow-y: scroll;
          margin: 0 20px;
          margin-bottom: 20px;
          box-sizing: border-box;
          li {
            font-size: 12px;
            color: rgba(51, 51, 51, 1);
            &:hover {
              font-size: 12px;
              color:#3FA6FF;
              color: var(--df-primary-color, #3FA6FF);
            }
          }
        }
      }
    }
    .stock {
      margin-left: 20px;
      color: rgba(51, 51, 51, 1);
    }
    .noStock {
      margin-left: 20px;
      color: #f44545;
    }
    .logistics {
      margin-left: auto;
      // margin-right: 20px;
      li {
        margin-left: 28px;
        position: relative;
        font-size: 13px;
        font-weight: 400;
        p {
          color: rgba(51, 51, 51, 1);
          &::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background:#3FA6FF;
            background: var(--df-primary-color, #3FA6FF);
            position: absolute;
            left: -10px;
            top: 50% - 2px;
          }
        }
      }
    }
  }
  .epidemicDeliverTip{
    height: 32px;
    font-size: 14px;

    font-weight: 500;
    color: #F44545;
    line-height: 32px;
    margin: 18px 0 -16px 50px;
    padding-left: 23px;
    background: url(~@/assets/images/icon_deliver_tip.png) left center no-repeat;
    background-size: 16px 16px;
  }
}
</style>
